export const listQuickView = {
  data: [
    {
      partnerId: 8,
      code: "AXA",
      name: "AXA",
    },
    {
      partnerId: 26,
      code: "BAOVIET",
      name: "Bao Viet",
    },
    {
      partnerId: 40,
      code: "GEGI",
      name: "Great Eastern General Insurance",
    },
    {
      partnerId: 7,
      code: "LOLI",
      name: "Lojaya Life Insurance",
    },
    {
      partnerId: 34,
      code: "MSIG",
      name: "MSIG",
    },
    {
      partnerId: 46,
      code: "MSIGVN",
      name: "MSIG Vietnam",
    },
    {
      partnerId: 2,
      code: "SIMAS",
      name: "Simas Insurtech",
    },
    {
      partnerId: 6,
      code: "ALLIANZ",
      name: "Zurich",
    },
  ],
  meta: {
    total: 8,
  },
  status: "200",
  message: "success list partners",
};

export const listProductCategory = {
  data: [
    {
      id: -999999,
      code: "",
      name: "All Products",
    },
    {
      id: 1,
      code: "EB",
      name: "Group Health",
    },
    {
      id: 13,
      code: "EB_SME",
      name: "EB SME",
    },
    {
      id: 2,
      code: "MV",
      name: "Motor Vehicle",
    },
    {
      id: 3,
      code: "PR",
      name: "Property",
    },
    {
      id: 4,
      code: "MC",
      name: "Marine Cargo",
    },
    {
      id: 5,
      code: "MH",
      name: "Marine Hull",
    },
    {
      id: 6,
      code: "LA",
      name: "Liabilities",
    },
    {
      id: 7,
      code: "PG",
      name: "PA Group",
    },
    {
      id: 8,
      code: "TV",
      name: "Travel",
    },
    {
      id: 9,
      code: "EN",
      name: "Engineering",
    },
    {
      id: 10,
      code: "CL",
      name: "Credit Life",
    },
    {
      id: 11,
      code: "BD",
      name: "Surety Bond",
    },
    {
      id: 12,
      code: "OTHER",
      name: "Others",
    },
  ],
  meta: {
    total: 2,
  },
  status: "200",
  message: "success list product category",
};
